import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HoverTooltip from '../HoverTooltip';
import './snakeBlock.css';
 
const SnakeBlock = ({ info, showGoBack, guessStatus }) => {
    if(!info) {
        return null
    }
    const renderTitle = () => (
        <>
            {info.type === 'MEDIA' ? info.title : info.name}
            {info.select_count === 0 &&
                <HoverTooltip info={`1st ever use of ${info.type === 'MEDIA' ? info.title : info.name}`}>
                    <FontAwesomeIcon 
                        icon={["fas", "award"]}
                        color='rgb(187,165,61)'
                        style={{marginLeft:5, marginTop:5}}
                    />
                </HoverTooltip>
            }
            <br />
            {info.type === 'MEDIA' ? info.year : info.date_of_birth?.split("-")[0]}
        </>
    );

    const setBorderStyle = () => {
        if(info.strike) {
            return '3px solid rgb(255,0,0)';
        }
        else if(info.select_count === 0) {
            return '3px solid rgb(187,165,61)';
        }
        else if(info.hint) {
            return '3px dashed #ccc';
        }
        else if(guessStatus?.id === info.id && guessStatus?.success) {
            return '3px solid #4caf50';
        }
        else {
            return '3px solid transparent';
        }
    }

    return (
        <div onClick={() => showGoBack()} className="snake-block media-block">
            <div className={`media-container ${info.strike ? "x-visible" : ""}`}>
                <img 
                    src={`https://image.tmdb.org/t/p/w300_and_h450_bestv2/${info.image}`} 
                    alt="Image" 
                    className="media-img"
                    style={{
                        border: setBorderStyle()
                      }}
                />
            </div>                
            <h3 className="media-title" style={{margin:0}}>
                {renderTitle()}
            </h3>
        </div>
    );
    }

export default SnakeBlock;
